module.exports = __webpack_public_path__ + "img/CY120005.172923b9.png";